// api/app.js
import request from './request'

export const appApi = {
    // 获取应用列表
    getList(params) {
        return request({
            url: '/app/list',
            method: 'get',
            params: {
                advertiserId: params.advertiserId,
                appPlatformIds: params.appPlatformIds ? params.appPlatformIds.join(',') : '',
                page: params.page || 1,
                pageSize: params.pageSize || 50
            }
        })
    },

    // 获取应用详情
    getInfo(advertiserId, appId) {
        return request({
            url: '/app/info',
            method: 'get',
            params: { advertiserId, appId }
        })
    },

    // 获取小程序/小游戏列表
    getMinisList(params) {
        return request({
            url: '/app/minis',
            withCredentials: false,
            method: 'get',
            params: {
                advertiserId: params.advertiserId,
                minisType: params.minisType || '',
                page: params.page || 1,
                pageSize: params.pageSize || 50
            }
        })
    }
}